import { ItemByDatesType } from 'app/dataTypes/reports/data/common/financesSummary'
import SimpleDate from 'app/common/classes/simple-date'
import toFixedValue from 'app/common/lib/toFixedValue'

import { ApiItemByDates } from './financesSummary'

const dateFormat = 'DD.MM.YY' as const

export const convertByDates = (
  rows: Array<ApiItemByDates>,
  nullValueForFinalDate = false,
): Array<ItemByDatesType> => {
  const res = rows.map(
    (
      {
        date,
        balance_before: balanceBefore,
        balance_before_exists: balanceBeforeExists,
        balance_after: balanceAfter,
        balance_after_exists: balanceAfterExists,
        payments,
        payments_negative: paymentsNegative,
        correction_payments: correctionPayments,
        correction_payments_negative: correctionPaymentsNegative,
        write_offs: writeOffs,
        payments_result: paymentsResult,
        correction_payments_result: correctionPaymentsResult,
        check,
      },
      index,
    ): ItemByDatesType => ({
      date: new SimpleDate(date, dateFormat),
      balanceBefore: toFixedValue(balanceBefore),
      balanceBeforeExists,
      balanceAfter:
        index === rows.length - 1 && nullValueForFinalDate && balanceAfter === 0
          ? null
          : toFixedValue(balanceAfter),
      balanceAfterExists,
      payments: toFixedValue(payments),
      paymentsNegative: toFixedValue(paymentsNegative),
      correctionPayments: toFixedValue(correctionPayments),
      correctionPaymentsNegative: toFixedValue(correctionPaymentsNegative),
      writeOffs: toFixedValue(writeOffs),
      paymentsResult: toFixedValue(paymentsResult),
      correctionPaymentsResult: toFixedValue(correctionPaymentsResult),
      check:
        index === rows.length - 1 && nullValueForFinalDate && balanceAfter === 0
          ? null
          : toFixedValue(check),
    }),
  )
  return res.sort((a, b) => (a.date.isBefore(b.date) ? -1 : 1))
}
